
const Warp = () => import('@/pages/warp/Warp');
const CompanyManagement = () => import('@/pages/warp/sidebar/CompanyManagement');
const MenuManagement = () => import('@/pages/warp/sidebar/menu-management/menu-management');
const AssetManagement = () => import('@/pages/warp/sidebar/AssetManagement');
const Seting = () => import('@/pages/warp/sidebar/Seting');
const OrganizationManagement = () => import('@/pages/warp/company/OrganizationManagement');
const NewOrganizational = () => import('@/pages/warp/company/NewOrganizational');
const OrganizationalStructure = () => import('@/pages/warp/company/OrganizationalStructure');
const DriverManagement = () => import('@/pages/warp/company/DriverManagement');
const ClerkManagement = () => import('@/pages/warp/company/ClerkManagement');
const OperatorManagement = () => import('@/pages/warp/company/OperatorManagement');
const TrafficDiversion = () => import('@/pages/warp/asset/TrafficDiversion');
const ExternalOrder = () => import('@/pages/warp/asset/TrafficDiversion');
const CarShareOrder = () => import('@/pages/warp/asset/CarShareOrder');
const CarSharePrice = () => import('@/pages/warp/asset/CarSharePrice');
const VehicleArchive = () => import('@/pages/warp/asset/VehicleArchive');
const DriverArchive = () => import('@/pages/warp/asset/DriverArchive');

const SystemClassSeting = () => import('@/pages/warp/seting/SystemClassSeting');
const SystemSeting = () => import('@/pages/warp/seting/SystemSeting');
const Dictionary = () => import('@/pages/warp/seting/Dictionary');
const TesSeting = () => import('@/pages/warp/seting/TesSeting');

const MenuManagementSet = () => import('@/pages/warp/seting/MenuManagementSet');

const Permissions = () => import('@/pages/warp/seting/Permissions');
const Operation = () => import('@/pages/warp/seting/Operation');
const carForeignModels = () => import('@/pages/warp/asset/carForeignModels');

export default [
    {
        path: '/warp',
        name: 'Warp',
        component: Warp,
        // redirect:'/warp/companymanagement/organizationmanagement',
        meta: {
            layout: true
        },
        children:[
            {
                path:'companymanagement',
                name:'公司管理',
                component:CompanyManagement,
                // redirect:'companymanagement/organizationmanagement',
                meta:{
                    layout:true
                },
                children:[
                    // {
                    //     path:'neworganizational',
                    //     name:'组织机构新增',
                    //     component:NewOrganizational,
                    // },
                    {
                        path:'organizationalstructure',
                        name:'组织机构结构图',
                        component:OrganizationalStructure,
                    },
                    {
                        path:'organizationmanagement',
                        name:'组织机构管理',
                        component:OrganizationManagement,
                    },
                    {
                        path:'organizationmanagement',
                        name:'组织机构新增',
                        component:OrganizationManagement,
                    },
                    
                    {
                        path:'drivermanagement',
                        name:'司机管理',
                        component:DriverManagement,
                    },
                    {
                        path:'clerkmanagement',
                        name:'业务员管理',
                        component:ClerkManagement,
                    },
                    {
                        path:'operatormanagement',
                        name:'系统账号管理',
                        component:OperatorManagement,
                    },
                    {
                        path:'operatormanagement',
                        name:'系统账户管理',
                        component:OperatorManagement,
                    },
                ]
            },
            {
                path:'assetmanagement',
                name:'资产管理',
                component:AssetManagement,
                // redirect:'assetmanagement/Trafficdiversion',
                meta:{
                    layout:true
                },
                children:[
                    {
                        path:'Trafficdiversion',
                        name:'车辆外调',
                        component:TrafficDiversion,
                    },
                    {
                        path:'carForeignModels',
                        name:'可外调车辆管理',
                        component:carForeignModels,
                    },
                    {
                    	path:'externalorder',
                    	name:'外调单管理',
                    	component:ExternalOrder
                    },
                    {
                        path:'car-share-order',
                        name:'车辆共享订单',
                        component:CarShareOrder
                    },
                    {
                        path:'car-share-price',
                        name:'车辆共享报价',
                        component:CarSharePrice
                    },
                    {
                        path:'vehicle-archive',
                        name:'车辆档案管理',
                        component:VehicleArchive
                    },
                    {
                        path:'driver-archive',
                        name:'司机档案管理',
                        component:DriverArchive
                    }

                    

                ]
            },
            {
                path:'测试dffA8',
                name:'测试dffA8',
                component:MenuManagementSet
            },
            {
                path:'seting',
                name:'设置',
                component:Seting,
                // redirect:'seting/permissions/operation',
                meta:{
                    layout:true
                },
                children:[
                    {
                        path:'systemclassseting',
                        name:'系统类设置',
                        component:SystemClassSeting,
                        children:[
                            {
                                path:'systemseting',
                                name:'系统设置',
                                component:SystemSeting,
                            },
                            {
                                path:'dictionary',
                                name:'数据字典',
                                component:Dictionary,
                            },
                            {
                                path:'menumanagement',
                                name:'菜单管理',
                                component:MenuManagement,
                            },

                        ]
                    },
                    {
                        path:'permissions',
                        name:'权限类设置',
                        component:Permissions,
                        children:[
                            {
                                path:'operation',
                                name:'操作权限设置',
                                component:Operation,
                            },                            
                        ]
                    },
                    
                ]
            },
            {
                path:'tesseting',
                name:'没有此页面',
                component:TesSeting,
            }
        ]
    },
]



// WEBPACK FOOTER //
// ./src/router/warp/warp.js